// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useMemo} from 'react';

interface i_use_swipe_props {
    on_left?: ()=>void;
    on_right?: ()=>void;
    on_top?: ()=>void;
    on_down?: ()=>void;
}
export const use_swipe = (props:i_use_swipe_props)=>{
    const state = useMemo(()=>({
        x: 0,
        y: 0,
    }), []);
    return {
        on_touch_start: (event:React.TouchEvent)=>{
            state.x = event.touches[0].clientX;
            state.y = event.touches[0].clientY;
        },
        on_touch_move: (event:React.TouchEvent)=>{
            if (!state.x || !state.y)
                return;
            const x = event.touches[0].clientX;
            const y = event.touches[0].clientY;
            const x_diff = state.x - x;
            const y_diff = state.y - y;

            if (Math.abs(x_diff) > Math.abs(y_diff))
            {
                if (x_diff>0)
                    props?.on_left();
                else
                    props?.on_right();
            }
            else
            {
                if (y_diff>0)
                    props?.on_top();
                else
                    props?.on_down();
            }
            state.x = null;
            state.y = null;
        },
    };
};
